module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE2IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjQwNTIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQ3MiA0LjAwOGwzLjkyNS41NzRhLjguOCAwIDAgMSAuNDQyIDEuMzY0TDEyIDguNzEybC42NyAzLjkwNmEuOC44IDAgMCAxLTEuMTYuODQzTDggMTEuNjE2bC0zLjUxIDEuODQ1YS44LjggMCAwIDEtMS4xNi0uODQzTDQgOC43MTIgMS4xNiA1Ljk0NmEuOC44IDAgMCAxIC40NDMtMS4zNjRsMy45MjUtLjU3NEw3LjI4My40NTNhLjguOCAwIDAgMSAxLjQzNCAwbDEuNzU1IDMuNTU1eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/investor/star.svg
// module id = WiXW
// module chunks = 1